import * as Sentry from "@sentry/react"
import { get } from "../tools"
import { SentryInitOptions } from "./types"

const ENV = process.env.REACT_APP_ENV

class SentryService {
    isInit = false

    create() {
        if (this.isInit) {
            return
        }
        const reportUrlMap = {
            dev: "https://54c5dc7bed49429effec73e5d73e45b4@sentry-sandbox.e107.cc/6",
            test: "https://54c5dc7bed49429effec73e5d73e45b4@sentry-sandbox.e107.cc/6",
            rc: "https://54c5dc7bed49429effec73e5d73e45b4@sentry-sandbox.e107.cc/6",
            prod: "https://7becad8141fa9308c5c7f78c92740a7a@sentry-sandbox.e107.cc/7",
        }
        const reportUrl = get(reportUrlMap, `${ENV}`, reportUrlMap.dev)
        Sentry.init({
            dsn: reportUrl,
            integrations: [
                new Sentry.BrowserTracing({
                    // 控制哪些域名需要追踪
                    tracePropagationTargets: [/https?:\/\/.*/],
                }),
                new Sentry.Replay({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            ],
            enabled: ENV !== "DEV",
            // Performance Monitoring
            tracesSampleRate: 1.0, // Capture 100% of the transactions
            // Session Replay
            replaysSessionSampleRate: 0.3, // 表示只有30%的用户会被重放
            replaysOnErrorSampleRate: 1.0, // 记录错误的概率
        })

        this.isInit = true
    }

    captureException(error: Error) {
        Sentry.captureException(error)
    }

    init = (params: SentryInitOptions) => {
        Sentry.setUser({
            username: params.userInfo.username,
            id: params.userInfo.id,
        })
        Sentry.setContext(`${ENV}_userContent`, {
            ...params,
            domain: window.location.href,
            Navigator: {
                ...window.navigator,
            },
        })
    }

    report = (obj: Record<string, any>, msg: string) => {
        if (ENV === "DEV") {
            return
        }
        Sentry.addBreadcrumb(obj)
        Sentry.captureException(msg)
    }
}

const errorReport = new SentryService()

export default errorReport
